import React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

import { Button, CollapseIcon, ExpandIcon, IconContainer } from './styles';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  expanded: boolean;
}

// Prefer using ExpandButton in new code and gradually replace legacy DetailsCollapseButton usages.
const ExpandButton: React.FC<Props> = ({ expanded, ...props }) => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Button expanded={expanded} {...props}>
      <SwitchTransition mode="in-out">
        <CSSTransition
          key={expanded ? 'collapse-details' : 'expand-details'}
          addEndListener={(node, done) => {
            node.addEventListener('transitionend', done, false);
          }}
        >
          <IconContainer>
            {expanded ? <CollapseIcon /> : <ExpandIcon />}
          </IconContainer>
        </CSSTransition>
      </SwitchTransition>
    </Button>
  );
};

export default ExpandButton;
